import { isEqual } from "lodash";
import React from "react";
import { Page } from "react-pdf";

interface PdfDocumentPagesProps {
  numPages: number | null;
}

const PdfDocumentPages = ({ numPages }: PdfDocumentPagesProps) => {
  if (!numPages) return null;

  return (
    <>
      {Array.from({ length: numPages }, (_, index) => (
        <Page
          key={`page_${index + 1}`}
          pageNumber={index + 1}
          width={1024}
          renderAnnotationLayer
          renderTextLayer
          renderForms
          className="pdf-page"
        />
      ))}
    </>
  );
};

export default React.memo(PdfDocumentPages, (prevProps, nextProps) => {
  return isEqual(prevProps, nextProps);
});
